// extracted by mini-css-extract-plugin
export default {"productGallery":"sH-z","inQuickShop":"tH-z"};